import { render, staticRenderFns } from "./CreateTransitOrProposedTransitLeadTime.vue?vue&type=template&id=41016bc8&scoped=true&"
import script from "./CreateTransitOrProposedTransitLeadTime.vue?vue&type=script&lang=js&"
export * from "./CreateTransitOrProposedTransitLeadTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41016bc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCol,VRow})
